import { ReactNode } from 'react';
import SanitizedHtml from '../../SanitizedHtml/SanitizedHtml';
import './CmsStory.css';
import { CmsMeta } from '../cmsMeta';

type CmsStoryProps = {
	title: string;
	content: string;
	image?: string;
	align?: 'left' | 'right';
	children?: ReactNode;
};

export const CmsStory = ({ title, content, image, align = 'left', children }: CmsStoryProps): JSX.Element => {
	const isReversed = align === 'right';

	return (
		<section className={`cms-story ${isReversed ? 'cms-story--reversed' : ''}`}>
			{image && (
				<div className="cms-story__image">
					<img src={image} alt={title || 'Story image'} />
				</div>
			)}
			<div className="cms-story__body">
				{title && <h2 className="cms-story__title">{title}</h2>}
				{content && <SanitizedHtml html={content} className="cms-story__content" />}
				{children}
			</div>
		</section>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'A picture beside a heading and some text, for telling a longer story in sections down a page. `align` puts the picture on the left or the right, so alternating them makes a zigzag. `content` takes simple html; anything given as children, such as a CmsButton, goes under the text.',
	example: [
		'CmsStory',
		{
			title: 'Feel Good med Leitz Ergonomi',
			align: 'left',
			image: 'https://cdn.ondio.com/assets/14e57f0fcab746a0921eebd4be9d1b85.jpg',
			content:
				'<p>Bra ergonomisk design är mer än kroppsmedveten funktionalitet. Det får dig att känna dig i harmoni med din kropp, så att inget distraherar eller känns obekvämt.</p>',
		},
		[
			'CmsButton',
			{
				linkTo: '/varumarken/leitz',
			},
			'Se Leitz Ergo',
		],
	],
};
